import _ from 'lodash'
import {
    SET_MESSAGES,
    ADD_MESSAGE,
    RESHOW_LATEST_MOTD,
    MOTD_FETCHING,
    MOTD_FETCHED,
    MOTD_FETCH_FAILED,
} from './constants'
import { REMOVE_TOAST, REMOVE_TOASTS } from '../constants'

// Initial state of the store
const initialState = {
    latestId: -1,
    latestTimeStamp: 0,
    tempTimeStamp: null,
    motds: {},
}

// Commands for the state machine
const motds = (state = initialState, action) => {
    const { payload, type } = action
    switch (type) {
        case MOTD_FETCHING: {
            const clone = _.cloneDeep(state)
            const { locale, timeStamp } = payload

            // We are simply adding a new language
            if (clone.latestTimeStamp === timeStamp) {
                clone.motds[clone.latestId].localized[locale] = { fetching: true }
            } else {
                // We are receiving this motd for the first time
                clone.tempTimeStamp = timeStamp
            }

            return clone
        }

        case ADD_MESSAGE:
        case MOTD_FETCHED: {
            const clone = _.cloneDeep(state)
            const { locale, toast } = payload

            const localized = {
                title: toast.title,
                content: toast.content,
            }

            // We are simply adding a new language
            if (clone.latestId === toast.id) {
                clone.motds[toast.id].localized[locale] = localized
            } else {
                // If this is a fetched motd, then clear the tempTimeStamp
                if (type === MOTD_FETCHED) {
                    clone.tempTimeStamp = null
                }

                // We are adding a new motd
                if (toast.motd.timeStamp > clone.latestTimeStamp) {
                    clone.latestId = toast.id
                    clone.latestTimeStamp = toast.motd.timeStamp
                }

                // MOTDs over 1 day old, when fetched from service should not be displayed
                // @CCP_Avalon 2018-08-13 - Added as a measure to prevent ghost MOTDs from appearing
                const offset = 1000 * 60 * 60 * 24
                const cutoffDateTime = new Date()
                cutoffDateTime.setTime(cutoffDateTime.getTime() - offset)

                if (new Date(toast.motd.timeStamp).getTime() < cutoffDateTime.getTime()) {
                    toast.visible = false
                    toast.seen = true
                }

                // Add the new language
                toast.localized = { [locale]: localized }

                clone.motds[toast.id] = toast
            }

            return clone
        }

        case MOTD_FETCH_FAILED: {
            const clone = _.cloneDeep(state)
            const { locale, timeStamp } = payload

            // We are simply trying to add a new language
            if (clone.latestTimeStamp === timeStamp) {
                delete clone.motds[clone.latestId].localized[locale]
            } else {
                clone.tempTimeStamp = null
            }

            return clone
        }

        // MOTDS from localforage
        case SET_MESSAGES: {
            // First we clone the current state
            const clone = _.cloneDeep(state)

            // Run through all supplied motds
            payload.forEach((motd) => {
                // First add it to state
                clone.motds[motd.id] = motd

                // Is this the latest motd we have seen?
                if (motd.motd.timeStamp > clone.latestTimeStamp) {
                    // Update the latest id and timestamp
                    clone.latestId = motd.id
                    clone.latestTimeStamp = motd.motd.timeStamp
                }
            })

            // Finally we return an updated state
            return clone
        }

        // Dismiss a toast
        case REMOVE_TOAST: {
            // Only process messages
            if (!payload.isMessage) return state

            const motd = _.cloneDeep(state.motds[payload.id])
            if (motd == null) return state

            // Mark the motd as seen and reset the count since last dismissed
            motd.seen = true
            motd.countSinceLastDismissal = 0

            if (!motd.dismissible) {
                return {
                    ...state,
                    motds: {
                        ...state.motds,
                        [motd.id]: motd,
                    },
                }
            }

            // If this is the latest message, we only want to hide it
            if (motd.id === state.latestId) {
                motd.visible = false
            } else {
                motd.dismissed = payload.dismissed
            }

            return {
                ...state,
                motds: {
                    ...state.motds,
                    [motd.id]: motd,
                },
            }
        }

        // Dismiss all given toasts
        case REMOVE_TOASTS: {
            if (payload.ids == null || payload.ids.length < 1) return state

            // Clone the entire toasts object
            const messages = _.cloneDeep(state.motds)
            if (_.isEmpty(messages)) return state

            // Loop through the given ids, and update the state
            // accordingly
            payload.ids.map((id) => {
                const motd = messages[id]

                // No motd with given id found
                if (motd == null) {
                    return 0
                }

                // Mark the toast as seen and reset the count since last dismissed
                motd.seen = true
                motd.countSinceLastDismissal = 0

                if (!motd.dismissible) {
                    return 0
                }

                // If this is the latest message, we only want to hide it
                if (motd.id === state.latestId) {
                    motd.visible = false
                } else {
                    motd.dismissed = payload.dismissed
                }

                return 0
            })

            return {
                ...state,
                motds: messages,
            }
        }

        // Reshow the latest motd
        case RESHOW_LATEST_MOTD: {
            if (state.latestId < 0) return state

            if (state.motds[state.latestId] == null) return state

            const motd = { ...state.motds[state.latestId] }
            motd.visible = true

            return {
                ...state,
                motds: {
                    ...state.motds,
                    [motd.id]: motd,
                },
            }
        }

        // Default state
        default:
            return state
    }
}

export default motds



// WEBPACK FOOTER //
// ./src/features/Toaster/data/motds/reducer.js